import { input } from '@b2b/types/core';
import angular from 'angular';

class OrderSummaryController {
  static $inject = ['$element'];

  orderTotal = input<number>(0);
  previousPayment = input<number>(0);
  balanceDue = input<number>(0);
  orderDifference = input<number>(0);

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-order-summary');
  }

  getRefundDue(amount: number): number {
    return Math.abs(amount || 0) * -1;
  }
}

export const OrderSummaryComponentModule = angular
  .module('acme.view.application.orders.edit.components.order-summary', [])
  .component('acmeOrderSummary', {
    templateUrl: `views/application/views/orders/edit/components/order-summary/order-summary.component.tpl.html`,
    controller: OrderSummaryController,
    controllerAs: '$ctrl',
    bindings: {
      orderTotal: '<',
      previousPayment: '<',
      balanceDue: '<',
      orderDifference: '<',
    },
  }).name;
